import React, { useCallback } from 'react'
import objectFitImages from 'object-fit-images'

import Image from './Image'

export default props => (
  <Image
    {...props}
    htmlAttributes={{
      alt: props.alt,
      ...props.htmlAttributes,
      ref: useCallback(objectFitImages),
    }}
  />
)
